"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormFieldEntitySelectMultiple = exports.FormFieldEntitySelect = exports.FormFieldEntitySelectDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var entity_select_1 = require("../../components/entities/entity-select");
var cls = (0, utils_1.classNames)('field-entity-select');
exports.FormFieldEntitySelectDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var SelectStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Select: (0, styled_components_1.default)(entity_select_1.EntitySelect)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles)
};
var FormFieldEntitySelect = function (props) {
  var className = props.className,
    onChange = props.onChange,
    autoFocus = props.autoFocus,
    isMultiple = props.isMultiple,
    disabled = props.disabled,
    name = props.name,
    entityTypeName = props.entityTypeName;
  // TODO - Does react-select pass the event through?  
  var handleChange = function (option) {
    if (option) {
      onChange({
        value: option,
        mutationValue: option.value
      });
    } else {
      // the new value is empty (select has been cleared)
      onChange({
        value: '',
        mutationValue: ''
      });
    }
  };
  var handleMultipleChange = function (options) {
    if (options) {
      onChange({
        value: options,
        mutationValue: options.map(function (option) {
          return option.value;
        })
      });
    } else {
      // the new value is empty (select has been cleared)
      onChange({
        value: [],
        mutationValue: []
      });
    }
  };
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, react_1.default.createElement(My.Select, {
    isDisabled: disabled,
    entityTypeName: entityTypeName,
    name: name,
    autoFocus: autoFocus,
    isMulti: isMultiple,
    onChange: isMultiple ? handleMultipleChange : handleChange
  }));
};
exports.FormFieldEntitySelect = FormFieldEntitySelect;
exports.FormFieldEntitySelect.cls = cls;
exports.FormFieldEntitySelect.defaultProps = exports.FormFieldEntitySelectDefaultProps;
var FormFieldEntitySelectMultiple = function (props) {
  return react_1.default.createElement(exports.FormFieldEntitySelect, __assign({}, props, {
    isMultiple: true
  }));
};
exports.FormFieldEntitySelectMultiple = FormFieldEntitySelectMultiple;
exports.FormFieldEntitySelectMultiple.cls = cls;
exports.FormFieldEntitySelectMultiple.defaultProps = exports.FormFieldEntitySelectDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;